import React, { useState } from 'react';
import CRMLayout from './layout/CRMLayout';
import Dashboard from './pages/Dashboard/Dashboard';
import Clients from './pages/Clients/Clients';
import Users from './pages/Users/Users';

const CRMApp = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <CRMLayout activeTab={activeTab} setActiveTab={setActiveTab}>
      {activeTab === 'dashboard' && <Dashboard />}
      {activeTab === 'clients' && <Clients filter="all" />}
    </CRMLayout>
  );
};

export default CRMApp;
